import Observer from '../../common/scripts/observer';
import tmplHiddenList from './template/hiddenList.twig';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class FlatTicketOptions {
    init(options = {}) {
        this.optionsWrapper = options.target;
        this.optionsList = this.optionsWrapper.querySelector('.j-flat-options') || null;
        this.optionsListTable = this.optionsWrapper.querySelector('.j-flat-options-table') || null;
        this.children = Array.from(this.optionsList.querySelectorAll('li'));
        this.salePin = this.optionsWrapper.querySelector('.j-sale-pin') || null;
        this.hiddenItems = [];
        this.hiddenList = null;
        this.hiddenListWrapper = null;
        this.hiddenListBtn = null;
        // Размер добавляемой кнопки
        this.offset = 40;
        this.wrapperWidth = this.optionsWrapper.offsetWidth || 0;

        // Ширина 1 опции
        this.childWidth = 0;
        // Массив размеров опций
        this.childWidthArray = [];
        this.isReady = false;
        this.readyClass = 'is-ready';

        this._setState();
        this._bindEvents();
        this._scoreBoard();
    }

    _bindEvents() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, Utils.debounce(() => {
                this.wrapperWidth = this.optionsWrapper.offsetWidth || 0;
                this._setState();
            }, 100));
        });
    }

    _setState() {
        // Заполняем массив с ширинами опций
        this._fillArray();

        // Собираем индексы элементов которые умещаются в карточке
        // если это не индексы внутри таблицы, там всегда 1
        let indexes = [];
        const isTable = this.optionsList.classList.contains('j-flat-options-table');

        if (!isTable) {
            indexes = this._checkSizes();
        }

        if (indexes.length === 0) {
            indexes = [0];
        }

        // Если индексы есть, то скрываем что не умещается и показываем кнопку
        // if (indexes && indexes.length && !this.salePin) {
        //     this.hiddenItems = this.children.slice(indexes.length);
        // } else if (this.children.length || this.salePin) {
        //     this.hiddenItems = this.children;
        // }
        //
        // if (this.hiddenItems.length) {
        //     if (!isTable) {
        //         this._insertHiddenList();
        //     }
        //
        //     this._removeVisibleElement(this.hiddenItems.length);
        // }

        this.optionsWrapper.classList.add(this.readyClass);
    }

    /**
     * Собираем массив с ширинами всех элементов
     */
    _fillArray() {
        this.children.forEach((item) => {
            const style = item.currentStyle || window.getComputedStyle(item);
            const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
            const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);

            this.childWidthArray.push(item.offsetWidth + padding + margin);
        });
    }

    /**
     * Собираем массив индексов элементов
     * @returns {Array} возвращает массив с индексами элементов, которые умещаются в карточке квартиры
     */
    _checkSizes() {
        const maxWidth = this.wrapperWidth - this.offset;

        const visibleIndexes = [];

        if (this.childWidthArray || !(this.childWidthArray.length === 1 && maxWidth > this.childWidthArray[0])) {
            this.childWidthArray.reduce((acc, current, index) => {
                if ((acc + current) < maxWidth) {
                    visibleIndexes.push(index);
                }

                return acc + current;
            }, 0);
        }


        return visibleIndexes;
    }

    /**
     * Скрываем элементы с конца списка
     * @param {integer} length - количество элементов для скрытия
     */
    _removeVisibleElement(length) {
        for (let i = 0; i < length; i++) {
            const lastElement = this.children.pop();

            lastElement.classList.add('is-hidden');
        }
    }

    /**
     * Выводим список и кнопку скрытых элементов
     */
    _insertHiddenList() {
        if (this.hiddenListWrapper) {
            Utils.removeElement(this.hiddenListWrapper);
        }

        Utils.insetContent(this.optionsWrapper, tmplHiddenList({hiddenItems: this.hiddenItems}));

        this.hiddenListWrapper = this.optionsWrapper.querySelector('.j-flat-options__additional') || null;
        this.hiddenList = this.optionsWrapper.querySelector('.j-flat-options__hidden-list') || null;
        this.hiddenListBtn = this.optionsWrapper.querySelector('.j-flat-options__show-more') || null;

        if (this.hiddenListBtn) {
            this.hiddenListBtn.addEventListener('click', (event) => {
                event.preventDefault();
            });
        }
    }

    /**
     * Включаем смену плашек в табличном отображении на мобиле
     */
    _scoreBoard() {
        if (this.optionsListTable) {
            const childrenTable = Array.from(this.optionsListTable.querySelectorAll('li'));
            let onIndex = 0;
            let scoreRun = 0;

            observer.subscribe('flatsList:table', () => {
                if (!childrenTable) {
                    return;
                }

                scoreRun = setInterval(() => {
                    childrenTable.forEach((item) => {
                        if (!item.classList.contains('is-hidden')) {
                            item.classList.add('is-escape');

                            setTimeout(() => {
                                item.classList.remove('is-escape');
                                item.classList.add('is-hidden');
                            }, 400);
                        }
                    });

                    childrenTable[onIndex]?.classList.remove('is-hidden');
                    childrenTable[onIndex]?.classList.add('is-show');

                    setTimeout(() => {
                        childrenTable[onIndex]?.classList.remove('is-show');
                        if (onIndex < childrenTable.length - 1) {
                            onIndex = onIndex + 1;
                        } else {
                            onIndex = 0;
                        }
                    }, 100);
                }, 2000);
            });

            observer.subscribe('flatsList:tile', () => {
                clearInterval(scoreRun);
            });
        }
    }
}

class FlatTicket {
    constructor() {
        /**
         * Целевой элемент
         */
        this.elem = null;

        /**
         * Класс для табличного вида
         * @type {string}
         */
        this.rowClass = 'flat-ticket_theme_row';
    }

    /**
     * Инициализация
     * @param {object} options - параметры
     */
    init(options) {
        this.elem = options.elem;

        this._getElements();
        this._bindEvents();
        this._subscribers();
    }

    /**
     * Получаем элементы
     * @private
     */
    _getElements() {
        this.closeBtn = this.elem.querySelector('.j-flat-ticket-close');
        this.openCard = this.elem.querySelector('.j-flat-ticket__open-card');
        this.area = this.elem.classList.contains('j-flat-ticket-promotion') ?
            false :
            this.elem.querySelector('.j-flat-ticket__area')?.innerText;
        this.price = this.elem.classList.contains('j-flat-ticket-promotion') ?
            false :
            this.elem.querySelector('.j-flat-ticket__price')?.innerText;
        this.rooms = this.elem.classList.contains('j-flat-ticket-promotion') ?
            false :
            this.elem.querySelector('.j-flat-ticket__rooms')?.innerText;
        this.sale = this.elem.classList.contains('j-flat-ticket-promotion') ?
            false :
            this.elem.querySelector('.j-sale-pin__percent');
        this.features = this.elem.querySelector('.flat-ticket__additional .j-flat-options') || null;
    }

    /**
     * Биндим события
     * @private
     */
    /* eslint-disable max-lines-per-function */
    _bindEvents() {
        this._bindEventsButtons();

        const resizeEvents = ['resize', 'orientationchange'];

        resizeEvents.forEach((resizeEvent) => {
            window.addEventListener(resizeEvent, () => {
                this._bindEventsButtons();
            });
        });

        // На квартиру навешиваем событие select_item, на баннер - go_constructor
        if (this.elem.classList.contains('j-flat-ticket-promotion')) {
            const id = this.elem.dataset.id;
            let bannerType = '';

            switch (id) {
                case '4':
                    bannerType = 'banner_ustupki';
                    break;
                case '5':
                    bannerType = 'banner_podstroika';
                    break;
                case '1':
                    bannerType = 'banner_news';
                    break;
                default:
                    break;
            }

            if (bannerType === '') {
                return;
            }

            this.elem.addEventListener('click', () => {
                try {
                    window.gtag('event', 'go_constructor', {
                        // eslint-disable-next-line
                        send_to: 'G-LLQN03TWXX',
                        place  : bannerType
                    });

                    // eslint-disable-next-line
                    console.log('go_constructor', bannerType);
                } catch (error) {
                    console.error(error);
                }
            });
        } else {
            const tags = this.features ? Array.from(this.features.querySelectorAll('.j-flat-option')) : [];
            const tagsArray = [];

            if (tags.length) {
                tags.forEach((item) => {
                    tagsArray.push(item.textContent.replace(/\n/g, '').trim());
                });
            }

            this.elem.addEventListener('click', (event) => {
                if (window.gtag) {
                    window.gtag('event', 'select_item', {
                        // eslint-disable-next-line
                        send_to: 'G-LLQN03TWXX',
                        rooms   : this.rooms,
                        square  : this.area,
                        price   : this.price,
                        discount: this.sale ? this.sale.innerText : 0,
                        tags    : tagsArray
                    });
                }

                if (this.elem.classList.contains('is-disabled')) {
                    event.preventDefault();
                }
            });
        }
    }
    /* eslint-enable max-lines-per-function */

    _bindEventsButtons() {
        if (!this.closeBtn || !this.openCard || !Utils.isMobile()) {
            return;
        }

        // навешиваем клики на табличные карточки в мобильной версии
        this.closeBtn.addEventListener('click', (event) => {
            event.preventDefault();

            this.elem.classList.remove('is-open');
        });

        this.openCard.addEventListener('click', (event) => {
            event.preventDefault();

            this.elem.classList.add('is-open');
        });
    }

    /**
     * Подписка на обновлнение из других модулей
     * @private
     */
    _subscribers() {
        observer.subscribe('flatsList:table', () => {
            this.elem.classList.add(this.rowClass);
        });

        observer.subscribe('flatsList:tile', () => {
            this.elem.classList.remove(this.rowClass);
        });
    }
}

export {FlatTicketOptions, FlatTicket};
